const isAny = (list, value) => (
  list.some((item) => { return (item === value) })
);

export default isAny;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/Any.tsx